import React from 'react'
import {Transition} from 'react-transition-group'
import { FaChevronLeft } from 'react-icons/fa'
import PropTypes from 'prop-types'

const duration = 300

const defaultStyle = {
  transition: `transform ${duration}ms ease-in-out`,
  transform: 'rotate(0deg)'
}

const transitionStyles = {
  entering: {transform: 'rotate(-90deg)'},
  entered: {transform: 'rotate(-90deg)'},
  exiting: {transform: 'rotate(0deg)'},
  exited: {transform: 'rotate(0deg)'}
}

const TransitionIcon = ({isOpen, style, iconStyle}) => (
  <Transition in={isOpen} timeout={duration}>
    {state => (
      <FaChevronLeft
        color="#4e4e4e"
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
          ...style,
          ...iconStyle,
          padding: '2px 0px 0px'
        }}
      />
    )}
  </Transition>
)

TransitionIcon.propTypes = {
  isOpen: PropTypes.bool,
  style: PropTypes.object,
  iconStyle: PropTypes.object
}

export default TransitionIcon
